var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { useId } from '../hooks';
import Description from './description';
import Error from './error';
import Label from './label';
import RequiredIndicator from './required-indicator';
import { wrapperStyle } from './styles';
function FormField(_a) {
    var children = _a.children, description = _a.description, error = _a.error, _b = _a.inverted, inverted = _b === void 0 ? false : _b, label = _a.label, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.requiredIndicator, requiredIndicator = _d === void 0 ? 'showOptional' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e;
    var id = useId();
    var fieldId = "form-field-".concat(id);
    var errorId = "form-field-error-".concat(id);
    var hasError = error != null;
    var element = cloneElement(children, __assign(__assign(__assign(__assign({ id: fieldId }, (required && { required: required })), (inverted && { inverted: inverted })), (hasError && {
        'aria-describedby': errorId,
        'aria-errormessage': errorId,
        error: true,
    })), { size: size }));
    return (_jsxs("div", __assign({ css: wrapperStyle({ inverted: inverted }) }, { children: [_jsxs(Label, __assign({ htmlFor: fieldId, size: size }, { children: [label, _jsx(RequiredIndicator, { indicator: requiredIndicator, isRequired: required, size: size })] })), description != null && (_jsx(Description, __assign({ size: size }, { children: description }))), element, hasError && (_jsx(Error, __assign({ id: errorId, size: size }, { children: error })))] })));
}
export default FormField;
